import { render } from "./PackSelector.vue?vue&type=template&id=6af8c26f&scoped=true"
import script from "./PackSelector.vue?vue&type=script&lang=js"
export * from "./PackSelector.vue?vue&type=script&lang=js"

import "./PackSelector.vue?vue&type=style&index=0&id=6af8c26f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/marvel-lcg-randomizer/marvel-lcg-randomizer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af8c26f"]])

export default __exports__